<template>
    <div class="content min-vh-100 flex-column d-flex justify-content-between">
        <section>
            <h2 class="title">
                24H EMERGENCY MEDICAL ASSISTANCE
            </h2>
            <hr />
            <div class="row mb-3">
                <div class="col">
                    <h3>WHY DO YOU CALL</h3>
                    <p>
                        Dear {{ fullName }},<br/>
                        by clicking this button you will dispatch a call to Axa Assistance Operations Center <b>(+ 39 06 42115723)</b>, available 24/7 for emergency events such as illness, injuries, hospitalization and medical consultation.
                    </p>
                    <p>
                        If you do not need urgent assistance, please:
                    </p>
                    <ul class="list">
                        <li>Visit the <router-link to="/contact-us">Contact Us</router-link> section for general information and updates about your claims</li>
                        <li>Visit the <router-link to="/file-claim">File Claim</router-link> section to file a reimbursement claim.</li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <h3>CALL PRICE</h3>
                    <p>Call price may vary according to your phone provider.</p>
                </div>
            </div>
        </section>
        <section class="need-help">
            <!-- <span class="font-italic">Call now</span> -->
            <div class="alert alert-primary d-flex text-center">
                <a href="tel:+390642115723"><span>24H EMERGENCY<br />MEDICAL ASSISTANCE</span></a>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    computed: {
        fullName: function(){
            //console.log("fullName");         
            return this.$store.state.userInfo.name;    
        }
    }
}
</script>